import { render, staticRenderFns } from "./BulkOrderContainer.vue?vue&type=template&id=23ba69d5&"
import script from "./BulkOrderContainer.vue?vue&type=script&lang=js&"
export * from "./BulkOrderContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports